import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=710e7ad0&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=710e7ad0&prod&lang=scss&scoped=true&"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=710e7ad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e7ad0",
  null
  
)

export default component.exports